import { request } from "../../../lib/requestHelper";

export const signInAPI = async (email, password) => {
    return await request('auth/sign-in', {
        method: "POST",
        body: JSON.stringify({
            email,
            password
        })
    });
};

// userData contains name, email, password, phone_number, role, active_role
export const signUpAPI = async (userData) => {
    return await request('auth/sign-up', {
        method: "POST",
        body: JSON.stringify(userData)
    });
};

export const forgotPasswordAPI = async (email) => {
    return await request('auth/forgot-password', {
        method: "POST",
        body: JSON.stringify({
            email
        })
    });
};

export const resetPasswordAPI = async (token, password) => {
    return await request(`auth/reset-password/${token}`, {
        method: "POST",
        body: JSON.stringify({
            password
        })
    });
};

export const uploadImageAPI = async (formData) => {
    return await request('api/profile/upload-artisan-profile-image', {
        method: "POST",
        body: formData
    });
};

export const verifyEmailAPI = async (token) => {
    return await request(`auth/verify-email/${token}`, {
        method: "GET"
    });
};

export const resendVerificationAPI = async () => {
    return await request('auth/resend-verification', {
        method: "POST"
    });
};
